import PageNames from "../pageNames";
import createSecuredApp from "../../helpers/createSecuredApp";
import DocumentSelection from "./DocumentSelection.vue";
import store from "./documentSelectionStore.js";

createSecuredApp(store, DocumentSelection, PageNames.DocumentSelection);
